<!-- =========================================================================================
    File Name: VxTimeline.vue
    Description: Timeline Component
    Component Name: VxTimeline
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <ul class="vx-timeline">
    <li v-for="item in data" :key="item.data.CompanyInfoId">
      <div class="timeline-icon" :class="`bg-${item.color}`">
        <feather-icon :icon="item.icon" svgClasses="text-white stroke-current w-5 h-5" />
      </div>
      <div class="timeline-info">
        <p style="margin-bottom: 0px !important" class="font-semibold">
          {{ item.data.Prefix }} - {{ item.title }}
          <span>
            <slot name="update-buttons" v-bind="item" />
          </span>
        </p>
        <span class="activity-desc">Api Key : {{ item.desc }}</span
        ><br />
        <span class="activity-desc">Api User : {{ item.data.ApiUser }}</span
        ><br />
        <span class="activity-desc">Api Password : {{ item.data.ApiPassword }}</span>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "vx-timeline",
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
